import {h, Component} from 'preact';
import {connect} from 'redux-zero/preact';
import actions from '../../store/actions';
import {withDeviceIndicator} from '../../hoc/withDeviceIndicator';
import {config} from "../../config";
import styles from './style.module.scss';
import {i18nService} from "../../services/i18n-service";

interface Props {
  [key: string]: any;
}

interface State {
}

const mapToProps = () => ({});

export class ErrorPage extends Component<Props, State> {
  render() {
    return (
        <div class={styles['not-found']}>
          <img src={`${config.publicPath}images/logos/face-frown.svg`} alt={''}/>
          <span class={styles['title']}>{i18nService.translate('error_page_404_title')}</span>
          <span class={styles['subtitle']}>{i18nService.translate('error_page_title')}</span>
          <span class={styles['text']}>{i18nService.translate('error_page_information')}</span>
          <span class={styles['text']}
                dangerouslySetInnerHTML={{__html: i18nService.translate('error_page_directive', config.homeUrl, config.homeUrl)}}></span>
        </div>
    );
  }
}

export default connect(mapToProps, actions)(withDeviceIndicator(ErrorPage));